import { render, staticRenderFns } from "./acrossOne.vue?vue&type=template&id=7efdd5f1&scoped=true&"
import script from "./acrossOne.vue?vue&type=script&lang=js&"
export * from "./acrossOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efdd5f1",
  null
  
)

export default component.exports